/*
  Fluxonix Agent Fetching Hook
  (c) 2025 Fluxonix Inc.
*/

import { useState, useEffect } from 'react';
import { api } from '../api';

export function useAgents() {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setErr('');

      try {
        const token = localStorage.getItem("fluxonix_token");
        const headers = token ? { Authorization: `Bearer ${token}` } : {};

        const { data } = await api.get('/api/agents/registry', { headers });
        console.log('✅ [useAgents] loaded:', data);

        // Expecting [{ id: "...", name: "...", enabled: true/false }]
        setAgents(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error('❌ [useAgents] failed:', e);
        setErr(e?.message || 'Failed to load agents');
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  return { agents, loading, err, setAgents };
}